import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const exportPayrollOrdersQuery = gql`
  query ExportPayrollOrders(
    $first_name: String
    $last_name: String
    $organisation_approval: String
    $order_status: String
    $employee_number: String
    $ni_number: String
    $pay_frequency: String
    $payroll_period: String
    $benefit_type: String
    $page: Int
    $show_employee_cancelled_orders: Boolean
    $order_number: Int
    $email: String
  ) {
    exportPayrollOrders(
      first_name: $first_name
      last_name: $last_name
      organisation_approval: $organisation_approval
      order_status: $order_status
      employee_number: $employee_number
      ni_number: $ni_number
      pay_frequency: $pay_frequency
      payroll_period: $payroll_period
      benefit_type: $benefit_type
      page: $page
      show_employee_cancelled_orders: $show_employee_cancelled_orders
      order_number: $order_number
      email: $email
    )
  }
`

export const getExportPayrollOrdersQueryKey = getQueryNames(exportPayrollOrdersQuery)[0]
